module.exports = __webpack_public_path__ + "static/media/home.4354be93.svg";